import moment from "moment";
import DataLoader from "../../../Utils/DataLoader";

export default function SportResult({ data, loading }) {
    if (loading) return <DataLoader />;

    if (!data?.length) {
        return <p className="text-center">No Result found</p>;
    }

    return (
        <section className="client-sec comedy">
            <div className="row justify-content-center">
                {data.map((ele, index) => (
                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xxl-4 mb-4">
                        <div key={index} className="resorts-box p-3 bg-white">
                        <figure>
                            <img src={ele?.images?.[1]?.url || ele?.images?.[0]?.url} className="img-fluid" alt={ele?.name} loading="lazy" />
                        </figure>
                        <div className="resorts-content-box">
                            <div className="resort-description p-0 m-0 border-0">
                                <h3>{ele?.name?.length > 35
                                    ? ele.name.slice(0, 35) + "..."
                                    : ele.name}</h3>
                            </div>
                            <div className="d-flex justify-content-between flex-wrap row-gap-2 location-box">
                                <span className="rating-star calandor-icon"><i className="fa-solid fa-calendar"></i>
                                    {ele?.dates?.start?.localDate
                                        ? moment(ele.dates.start.localDate).format("MMMM Do YYYY")
                                        : "TBA"}
                                </span>
                                <span className="rating-star"><i className="fa-solid fa-clock"></i>
                                    {ele?.dates?.start?.localTime
                                        ? new Date(
                                            `1970-01-01T${ele?.dates?.start?.localTime}`
                                        ).toLocaleTimeString([], {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                        })
                                        : ele?.dates?.start?.dateTime
                                            ? new Date(
                                                ele.dates.start.dateTime
                                            ).toLocaleTimeString([], {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                            })
                                            : "TBA"}
                                </span>
                                {/* <span className="rating-star location-icon"><i className="fa-solid fa-location-dot"></i>
                                    2113 N Kedzie Blvd.
                                </span> */}
                            </div>
                            <div className="book-trip-btn">
                                <a href={ele?.url} target="_blank"
                                    rel="noreferrer" className="w-100 text-center d-block">See More</a>
                            </div>
                        </div>
                    </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
